<template>
  <NuxtLayout>
    <div class="apiError container--Small">
      <div class="apiError__ImageWrapper">
        <Icon name="laptop" />
      </div>

      <h1 v-text="$t('error.title')" />

      <div class="apiError__Content">
        <template v-if="errorType === 'invalid_id'">
          <p v-text="$t('error.invalidIdText')" />
        </template>
        <template v-else-if="errorType === 'unit_not_available'">
          <p v-text="$t('error.unitNotAvailableText')" />
        </template>
        <template v-else>
          <p v-text="$t('error.generalText')" />
        </template>
        <i18n-t tag="p" keypath="error.generalContact" scope="global">
          <template #contact>
            <nuxt-link :to="link('Contact')">{{ $t('error.contact') }}</nuxt-link>
          </template>
        </i18n-t>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess'
  });

  defineProps(['page']);
  const { query } = useRoute();
  const { link } = useSetup();
  const errorType = ref(null);

  if (query?.error) errorType.value = query.error;
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_apiError.scss');
</style>